import Panel from 'portaltransparencia-common/components/Panel.react.js';
import SumListField from 'portaltransparencia-common/components/SumListField.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import DateUtils from 'portaltransparencia-common/libs/DateUtils';
import NumberUtils from 'portaltransparencia-common/libs/NumberUtils';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';
import LinkToEmpenho from '../empenhos/LinkToEmpenho.react';

export class GastoPecaTable extends Component {
  static propTypes = {
    gastosPeca: PropTypes.object.isRequired,
    idEntidade: PropTypes.any
  };

  renderGastoPeca = gastosPeca => {
    const key = `${gastosPeca.get('numero')}_${gastosPeca.get(
      'data'
    )}_${gastosPeca.get('item')}`;
    const { idEntidade } = this.props;

    return (
      <tr key={key}>
        <td>{gastosPeca.get('numero')}</td>
        <td>{DateUtils.transform(gastosPeca.get('data'))}</td>
        <td>{`${gastosPeca.get('centroDestino')} - ${gastosPeca.get(
          'centroDestinoDescricao'
        )}`}</td>
        <td>
          <LinkToEmpenho
            entidade={idEntidade}
            exercicio={gastosPeca.get('anoEmpenho')}
            empenho={gastosPeca.get('empenho')}
          />
        </td>
        <td>{gastosPeca.get('item')}</td>
        <td className="right">{gastosPeca.get('kmAnterior')}</td>
        <td className="right">{gastosPeca.get('kmAtual')}</td>
        <td className="right">{gastosPeca.get('mediaCombustivel')}</td>
        <td className="right">
          {NumberUtils.format(gastosPeca.get('quantidade'))}
        </td>
        <td className="right">{NumberUtils.format(gastosPeca.get('valor'))}</td>
        <td className="right">
          {NumberUtils.format(gastosPeca.get('valorTotal'))}
        </td>
      </tr>
    );
  };

  render() {
    const { gastosPeca } = this.props;

    return (
      <Panel title="Gastos com Peca do Veículo" isTable>
        <div className="panel-table-outer">
          <table className="panel-table striped fancy">
            <TableHeader
              empty={gastosPeca.isEmpty()}
              texto="Nenhum gasto encontrado."
            >
              <tr>
                <th>Número</th>
                <th>Data</th>
                <th>Centro Consumo</th>
                <th>Empenho</th>
                <th>Ítem</th>
                <th className="right">Km Anterior</th>
                <th className="right">Km</th>
                <th className="right">Média</th>
                <th className="right">Qtde.</th>
                <th className="right">Valor</th>
                <th className="right">Valor Total</th>
              </tr>
            </TableHeader>
            <tbody>{gastosPeca.map(this.renderGastoPeca)}</tbody>
            {!gastosPeca.isEmpty() && (
              <tfoot>
                <tr>
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td className="right">
                    <i>Total: </i>
                    <SumListField fieldName="valorTotal" list={gastosPeca} />
                  </td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </Panel>
    );
  }
}

export default GastoPecaTable;
